import React from 'react'
// import ContentSectionHeader from '../../../components/ContentSectionHeader'
import VehicleHeroFilterBar from '../../../components/VehicleHeroFilterBar'
import SplitHeroCarousel from '../../../components/SplitHeroCarousel'
import buildImageUrl from '../../../../lib/media-url-maker'
import {
  SearchHeroWrapper,
  SearchHeroWrapperInner,
  SearchHeroHeading
} from './SearchHeroWrapper'
import FormWrapper from './FormWrapper'
import { navigate } from 'gatsby'
import { isCar } from '../../../../lib/category-matcher'

const SearchHeroWidget = ({
  title,
  vehicleType,
  usedVehicles,
  makes,
  items = []
}) => {
  const heroProps = {
    type: vehicleType,
    makes
  }
  if (vehicleType === 'vans') {
    heroProps.hasMontlyPricing = true
  }
  items = items.map((item) => {
    item.src =
      item.images &&
      item.images.widgets &&
      item.images.widgets.length &&
      buildImageUrl({
        width: 800,
        mode: 'cover',
        resource: item.images.widgets[0].crops[0].src
      })

    return item
  })

  return (
    <SearchHeroWrapper>
      <SearchHeroWrapperInner>
        <SplitHeroCarousel slides={items} />
        <SearchHeroHeading dangerouslySetInnerHTML={{ __html: title }} />
        <FormWrapper>
          <VehicleHeroFilterBar
            onSearch={navigate}
            {...heroProps}
            usedVehicles={usedVehicles.map((vehicle) => ({
              ...vehicle,
              category: isCar(vehicle.category) ? 'Cars' : 'Vans'
            }))}
          />
        </FormWrapper>
      </SearchHeroWrapperInner>
    </SearchHeroWrapper>
  )
}

export default SearchHeroWidget
